import React from 'react';
import $ from 'jquery';
import { resource_url } from '../../common/cores/keys';
import { connect } from 'react-redux';
import { HidePopup } from '../../common/actions/moreAction';
import { isEmpty } from '../../common/cores';

const imgUrl = resource_url + "/images/popups/";

class Advertisement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checkBox: false
    }
  }

  ClickCloseButton = (id, checked) => {
    // $(`div.flexbox_popupadvertisement section#${id}`).addClass('napam-advertisement');
    if(checked) {
      // if(this.props.isAuthenticated){
      //   this.props.HidePopup(id);
      // }
      // else{
        const popupStr = localStorage.getItem("popup")
        const popupExp = Number(localStorage.getItem("popupExp"));
        const date = new Date();
        const popups = !isEmpty(popupStr) && (popupExp >= Date.UTC(date.getUTCFullYear(), (date.getUTCMonth() + 1), date.getUTCDate())) 
              ? JSON.parse(popupStr) : [];
        localStorage.setItem("popup", JSON.stringify([...popups, id]));

        localStorage.setItem("popupExp", Date.UTC(date.getUTCFullYear(), (date.getUTCMonth() + 1), date.getUTCDate()))
      // }
    }
  }

  render() {
    const { checkBox } = this.state;
    const { data, showed } = this.props;
    const { _id: id, url, type } = data;
    const actived = showed.findIndex(item => item === id) >= 0;
    // console.log(data, showed)

    return (
      <section
        id={id}
        className={"popup_window popup_advertisement " + (actived ? 'active' : '')}
      >
        <h5 className="XXX XX" onClick={e => { e.preventDefault(); this.ClickCloseButton(id, false); this.props.ToggleImage(id) }}>
          <span className="fa fa-close"></span>
        </h5>
        <div className="reg">
          <div className="top">
              <img src="../images/logo.png" alt=""/>
          </div>
          { (type == 0 || isEmpty(type)) ?
            <div className="content">
              <p>
                <img width="500" src={imgUrl + url} alt="" />
              </p>
            </div>
            :
            <div className='content'>
               <div className="padding-5 text-center" dangerouslySetInnerHTML={{ '__html': !isEmpty(url) ? url : "" }} style={{color:"#fff", background:"#565656"}}></div>
            </div>
          
        }
          <div className="btnZone">
              <button className="btnP greyBtn" onClick={e => { e.preventDefault(); this.ClickCloseButton(id, true); this.props.ToggleImage(id) }}>오늘 하루 열지 않기</button>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated
});

export default connect(mapStateToProps, {
  HidePopup
})(Advertisement);


// WEBPACK FOOTER //
// ./src/components/common/Advertisement.js